import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

import Date from 'src/components/ResumeCard/Body/DateInterval/Date';

const TrlKeys = {
    noStartDate: 'rb.date.not.added',
    noEndDate: 'rb.tilltoday',
};

interface Props {
    start: string;
    end: string;
}

const DateInterval: TranslatedComponent<Props> = ({ start, end, trls }) => {
    return (
        <span>
            <Date value={start} fallback={trls[TrlKeys.noStartDate]} />
            {' — '}
            <Date value={end} fallback={trls[TrlKeys.noEndDate]} />
        </span>
    );
};

export default translation(DateInterval);
